import {DatePipe, TitleCasePipe}            from '@angular/common';
import {booleanAttribute, Component, input} from '@angular/core';
import {FoodRecordLogIntf}                  from '@djsharkk/logr-types';
import {UiFoodRatingComponent}              from '../../ui/ui-food-rating/ui-food-rating.component';
import {TableRowBase}                       from '../table-row-base';
import {TableRow}                           from '../table-wrapper/table-wrapper.component';

@Component({
			   selector   : 'app-table-row-food',
			   imports: [
				   DatePipe,
				   TitleCasePipe,
				   UiFoodRatingComponent
			   ],
			   templateUrl: './table-row-food.component.html',
			   styleUrl   : './table-row-food.component.css'
		   })
export class TableRowFoodComponent extends TableRowBase<FoodRecordLogIntf> {
	row = input.required<TableRow<FoodRecordLogIntf>>();
	showDate = input(false, {transform: booleanAttribute});
	detailed = input(false, {transform: booleanAttribute});
}
